import { useSuspenseQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { dealTypeCategoryApis } from "./dealTypeCategory.service";

export const useDealTypeCategoryQuery = (
  draftArticleId = Number(getPressIdFromURL()),
) => {
  const articleSectionByClassification = useArticleSection();
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.dealTypeCategory, draftArticleId],
    queryFn: () => {
      if (!["Deals", "Deal LA&SC"].includes(articleSectionByClassification))
        return {
          data: {
            dealTypeCategory: "",
          },
          code: 200,
          message: "Not a Deals or Deal LA&SC article",
        };
      return dealTypeCategoryApis.get(draftArticleId);
    },
    select: ({ data }) => data.dealTypeCategory,
    gcTime: 0,
    staleTime: 0,
  });
};
